module.exports = __webpack_public_path__ + "05_long_yellow.09064aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_long_yellow.png
// module id = X8ca
// module chunks = 0